import { useAuthStore } from '../store/authStore';

export function usePermissions() {
  const user = useAuthStore((s) => s.user);
  const permissions = useAuthStore((s) => s.permissions);
  const isSystem = user?.isSystem ?? false;

  return {
    isSystem,
    permissions,

    hasPermission: (perm: string): boolean => isSystem || permissions.includes(perm),
    hasAnyPermission: (...perms: string[]): boolean => isSystem || perms.some((p) => permissions.includes(p)),

    canAccessAdmin: (): boolean => isSystem || permissions.some((p) => p.startsWith('tab:')),
    isSuperAdmin: (): boolean => isSystem,
    isAdmin: (): boolean => isSystem,
    isManager: (): boolean => isSystem || permissions.some((p) => p.startsWith('tab:')),
  };
}
